// import React, { useState, useEffect } from 'react'
// import Pagination from '../pagination/Pagination';
// import axios from 'axios'
// import { Link } from 'react-router-dom'
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

// // Import Material Icons



// const Advertisement = () => {

//   const [ad_image, set_ad_image] = useState()
//   const [ad_page, set_ad_page] = useState()

//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const [ad, setAd] = useState([])
//   const [showPerPage, setShowPerPage] = useState(10)
//   const [pagination, setPagination] = useState(
//     {
//       start: 0,
//       end: showPerPage
//     }
//   )

//   const onChangePagination = (start, end) => {
//     setPagination({ start: start, end: end })
//   }

// const advertisement_get = async () => {
//   const ad_page = 'web';
//   const dist = sessionStorage.getItem("dist");

//   const res = await axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/advertise/get`, {
//     ad_page,
//     dist
//   });

//   setAd(res.data);
// };

// const advertisement = (e) => {
//   e.preventDefault();
//   const formData = new FormData();

//   const dist = sessionStorage.getItem("dist"); // ✅ Get dist

//   formData.append('file', ad_image);
//   formData.append('ad_page', ad_page);
//   formData.append('dist', dist); // ✅ Append dist

//   const config = {
//     headers: {
//       'content-type': 'multipart/form-data'
//     }
//   };

//   axios.post("https://lionsdirectoryapi.emedha.in/notification/api/advertise/posting", formData, config)
//     .then((response) => {
//       alert(response.data);
//       setTimeout(() => setShow(false), 200);
//       advertisement_get();
//     });
// };



//   useEffect(() => {
//     advertisement_get()
//   }, []);

// const deleteAd = (id) => {
//   if (window.confirm('Are you sure to delete this data...')) {
//     const dist = sessionStorage.getItem("dist"); // ✅ Get dist

//     axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/advertise/delete`, {
//       id,
//       dist  // ✅ Send dist in body
//     })
//     .then((res) => {
//       alert('Data deleted successfully!');
//       advertisement_get(); // Refresh
//     })
//     .catch((err) => {
//       console.error("Delete error:", err);
//     });
//   }
// };


//   return (

//     <>
//       <Button variant="warning" onClick={handleShow}>
//         Add<PersonAddAltIcon></PersonAddAltIcon>
//       </Button>
//       <Modal show={show} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Add</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <form onSubmit={advertisement}>
//             <label style={{ marginLeft: '0.1rem' }}>Advertise page </label>
//             <select type='text' className='form-control' placeholder='Route' onChange={(e) => set_ad_page(e.target.value)} >
//               <option value='' disabled={false} >
//                 Advertise page
//               </option>
//               <option value='login'>
//                 login
//               </option>
//               <option value='signup'>
//                 signup
//               </option>
//               <option value='club'>
//                 club
//               </option>
//               <option value='member'>
//                 member
//               </option>
//               <option value='index'>
//                 index
//               </option>
//               <option value='welcome'>
//                 Welcome
//               </option>
//             </select>
//             <br />
//             <label style={{ marginLeft: '0.1rem' }}>Advertise Image </label>
//             <input type='file' className='form-control' placeholder='' name='file' onChange={(e) => set_ad_image(e.target.files[0])} />
//             <br />
//             <button type='submit' className='btn btn-danger form-control'>Submit</button>
//           </form>
//         </Modal.Body>

//       </Modal>
//       <div style={{ marginTop: '1rem' }} className='table-container'>
//         <table className="styled-table table table-bordered">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Image</th>
//               <th>Ad Page</th>
//             </tr>

//           </thead>
//           <tbody className='table-bordered'>
//             {

//               ad.slice(pagination.start, pagination.end).map((data, index) => {
//                 return (
//                   <tr>
//                     <td>{index + 1}</td>
//                     <img src={`${data.image}`} width='130px' />
//                     <td>{data.ad_page}</td>
//                     <td className=''>
//                       <Link to='#' className='btn btn-danger' onClick={() => deleteAd(data.id)}>delete</Link>
//                     </td>
//                   </tr>
//                 )
//               })
//             }
//           </tbody>
//         </table>
//         <Pagination page={showPerPage} onChangePagination={onChangePagination} total={ad.length} />
//       </div>
//     </>
//   )
// }

// export default Advertisement


import React, { useState, useEffect } from 'react'
import Pagination from '../pagination/Pagination';
import axios from 'axios'
import { Link } from 'react-router-dom'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

// Import Material Icons



const Advertisement = () => {

  const [ad_image, set_ad_image] = useState()
  const [ad_page, set_ad_page] = useState()

  const [title, setTitle] = useState("");
const [description, setDescription] = useState("");
const [editId, setEditId] = useState(null);
const [preview, setPreview] = useState(null);
  const [show, setShow] = useState(false);
const handleClose = () => {
  setShow(false);
  setEditId(null);
  setTitle("");
  setDescription("");
  set_ad_image(null);
  setPreview(null);
};
  const handleShow = () => setShow(true);

  const [ad, setAd] = useState([])
  const [showPerPage, setShowPerPage] = useState(10)
  const [pagination, setPagination] = useState(
    {
      start: 0,
      end: showPerPage
    }
  )

  const onChangePagination = (start, end) => {
    setPagination({ start: start, end: end })
  }

const advertisement_get = async () => {
  const dist = sessionStorage.getItem("dist");

  const res = await axios.post(
    "https://lionsdirectoryapi.emedha.in/notification/api/advertise/list",
    { dist }
  );

  setAd(res.data);
};

const handleSubmit = async (e) => {
  e.preventDefault();

  const dist = sessionStorage.getItem("dist");

  const formData = new FormData();
  formData.append("file", ad_image);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("dist", dist);

  try {
    if (editId) {
      await axios.put(
        `https://lionsdirectoryapi.emedha.in/notification/api/advertise/update/${editId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      alert("Updated successfully");
    } else {
      await axios.post(
        "https://lionsdirectoryapi.emedha.in/notification/api/advertise/create",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      alert("Created successfully");
    }

    handleClose();
    advertisement_get();

  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};


  useEffect(() => {
    advertisement_get()
  }, []);

const deleteAd = async (id) => {
  if (!window.confirm("Are you sure to delete this data?")) return;

  const dist = sessionStorage.getItem("dist");

  try {
    await axios.delete(
      `https://lionsdirectoryapi.emedha.in/notification/api/advertise/delete/${id}`,
      { data: { dist } }
    );

    alert("Deleted successfully");
    advertisement_get();
  } catch (err) {
    console.error(err);
    alert("Delete failed");
  }
};


  return (

    <>
      <Button variant="warning" onClick={handleShow}>
        Add<PersonAddAltIcon></PersonAddAltIcon>
      </Button>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form onSubmit={handleSubmit}>
<label>Image *</label>
<input
  type="file"
  className="form-control"
  accept="image/*"
  onChange={(e) => {
    const file = e.target.files[0];
    set_ad_image(file);

    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  }}
/>
{preview && (
  <div style={{ marginTop: "15px", textAlign: "center" }}>
    <img
      src={preview}
      alt="Preview"
      style={{
        width: "200px",
        height: "150px",
        objectFit: "cover",
        borderRadius: "8px",
        border: "1px solid #ddd"
      }}
    />
  </div>
)}
  <br />

  <label>Title (Optional)</label>
  <input
    type="text"
    className="form-control"
    value={title}
    onChange={(e) => setTitle(e.target.value)}
  />

  <br />

  <label>Description (Optional)</label>
  <textarea
    className="form-control"
    value={description}
    onChange={(e) => setDescription(e.target.value)}
  />

  <br />

  <button type="submit" className="btn btn-danger form-control">
    {editId ? "Update" : "Submit"}
  </button>
</form>
        </Modal.Body>

      </Modal>
      <div style={{ marginTop: '1rem' }} className='table-container'>
        <table className="styled-table table table-bordered">
          <thead>
    
  <tr>
    <th>S.No</th>
    <th>Image</th>
    <th>Title</th>
    <th>Description</th>
    <th>Actions</th>
  </tr>


          </thead>
         <tbody>
  {ad.slice(pagination.start, pagination.end).map((data, index) => (
    <tr key={data.id}>
       <td>{pagination.start + index + 1}</td>

      <td>
        <img src={data.image} width="130px" alt="ad" />
      </td>

      <td>{data.title || "-"}</td>

      <td>{data.description || "-"}</td>

      <td>
        <button
          className="btn btn-primary me-2"
          onClick={() => {
           setEditId(data.id);
setTitle(data.title || "");
setDescription(data.description || "");
setPreview(data.image); // 👈 show existing image
setShow(true);
          }}
        >
          Edit
        </button>

        <button
          className="btn btn-danger"
          onClick={() => deleteAd(data.id)}
        >
          Delete
        </button>
      </td>
    </tr>
  ))}
</tbody>
        </table>
        <Pagination page={showPerPage} onChangePagination={onChangePagination} total={ad.length} />
      </div>
    </>
  )
}

export default Advertisement